"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfiniteScroll = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const Flex_1 = tslib_1.__importDefault(require("./Elements/Flex"));
const InnerScroll = (0, styled_components_1.default)(Flex_1.default) `
  width: 100%;
  height: ${props => (props.height ? props.height : '100%')};

  flex-direction: column;
  overflow: auto;
`;
class InfiniteScroll extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.scrollRef = null;
        this.isInit = true;
        this.loading = false;
        this.scrollHeight = 0;
        this.onScroll = async () => {
            const { hasMore } = this.props;
            const { scrollRef, loading } = this;
            if (scrollRef &&
                scrollRef.scrollTop + scrollRef.clientHeight >= scrollRef.scrollHeight &&
                !loading &&
                hasMore) {
                this.loading = true;
                await this.props.loadMore();
                this.loading = false;
            }
        };
        this.state = {
            loading: false,
        };
    }
    componentDidMount() {
        if (this.scrollRef) {
            this.scrollRef.addEventListener('scroll', this.onScroll, false);
            this.scrollRef.addEventListener('change', this.onScroll, false);
        }
    }
    async componentDidUpdate() {
        const { scrollRef } = this;
        if (scrollRef &&
            scrollRef.clientHeight >= scrollRef.scrollHeight &&
            scrollRef.scrollHeight !== this.scrollHeight &&
            this.props.hasMore &&
            !this.loading) {
            this.scrollHeight = scrollRef.scrollHeight;
            this.loading = true;
            await this.props.loadMore();
            this.loading = false;
        }
    }
    componentWillUnmount() {
        if (this.scrollRef) {
            this.scrollRef.removeEventListener('scroll', this.onScroll, false);
        }
    }
    scrollTo(position) {
        if (this.scrollRef) {
            this.scrollRef.scrollTop = position;
        }
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { height, hasMore: _, loadMore: __, ...flexProps } = this.props;
        return (react_1.default.createElement(InnerScroll, { ref: (ref) => (this.scrollRef = ref), ...flexProps, height: height }, this.props.children));
    }
}
exports.InfiniteScroll = InfiniteScroll;
